import { Pipe, PipeTransform } from '@angular/core';
import { LocationGroup } from '../services/api-location-groups.service';
import { Location } from 'src/app/core/models/project/location.model';

@Pipe({
  name: 'floorHasAcLocationOrPassageRelay',
  standalone: false
})
export class FloorHasAcLocationOrPassageRelayPipe implements PipeTransform {

  transform(floor: LocationGroup): boolean {
          return floor.locations.some( (loc) => {
            return Location.isAccessControl(loc) || Location.isPassageRelay(loc)
          })
    }

}
